import { GENERAL_SEA_AREAS, TGeneralSeaAreasSliceState } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TGeneralSeaAreas } from "../types/downloadTypes";
import { RootState } from "../../../core/store";

const initialState: TGeneralSeaAreasSliceState = {
    generalSeaAreasData: null,
    generalSeaAreasLoading: false,
    generalSeaAreasError: null,
};

const generalSeaAreasSlice = createSlice({
    name: GENERAL_SEA_AREAS,
    initialState,
    reducers: {
        getGeneralSeaAreasRequestAction: (state: TGeneralSeaAreasSliceState, _: PayloadAction) => {
            state.generalSeaAreasLoading = true;
            state.generalSeaAreasError = null;
            state.generalSeaAreasData = null;
        },
        getGeneralSeaAreasSuccessAction: (state: TGeneralSeaAreasSliceState, { payload: data }: PayloadAction<TGeneralSeaAreas[]>,
        ) => {
            state.generalSeaAreasLoading = false;
            state.generalSeaAreasData = data;
            state.generalSeaAreasError = null;
        },
        getGeneralSeaAreasErrorAction: (state: TGeneralSeaAreasSliceState, { payload: error }: PayloadAction<any>,
        ) => {
            state.generalSeaAreasLoading = false;
            state.generalSeaAreasData = null;
            state.generalSeaAreasError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});


export const generalSeaAreasActions = {
    ...generalSeaAreasSlice.actions
};

export default generalSeaAreasSlice.reducer;

export const selectGeneralSeaAreas = (state: RootState) =>
    state.generalSeaAreasSlice.generalSeaAreasData;
export const selectGeneralSeaAreasLoading = (state: RootState) =>
    state.generalSeaAreasSlice.generalSeaAreasLoading;
export const selectGeneralSeaAreasError = (state: RootState) =>
    state.generalSeaAreasSlice.generalSeaAreasError;